// Versandzusage in der Buy Box (snippets/su-dispatch-promise.liquid): Zustand in Europe/Berlin nachrechnen,
// Restzeit bis zum Cutoff jede Minute aktualisieren. Der Server liefert bereits den richtigen Text, hier nur Korrektur.
if (!customElements.get('su-dispatch-promise')) {
  customElements.define('su-dispatch-promise', class extends HTMLElement {
    connectedCallback() {
      this.update();
      clearInterval(this.timer);
      this.timer = setInterval(() => this.update(), 60000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
    }
    update() {
      const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Berlin', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
      const get = (type) => (parts.find((p) => p.type === type) || {}).value;
      const weekday = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(get('weekday'));
      const hour = Number(get('hour'));
      const minute = Number(get('minute'));
      const cutoff = Number(this.dataset.cutoff || 14);
      let state = 'business';
      if (weekday >= 1 && weekday <= 5 && hour < cutoff) state = 'today';
      else if (weekday >= 1 && weekday <= 4 && hour >= cutoff) state = 'tomorrow';
      const left = cutoff * 60 - hour * 60 - minute;
      const time = Math.floor(left / 60) + 'h ' + (left % 60) + 'min';
      const title = this.dataset['title' + state[0].toUpperCase() + state.slice(1)] || '';
      const subline = (this.dataset['subline' + state[0].toUpperCase() + state.slice(1)] || '').replace('||time||', time);
      this.dataset.state = state;
      const t = this.querySelector('[data-title]');
      const s = this.querySelector('[data-subline]');
      if (t) t.textContent = title;
      if (s) s.textContent = subline;
    }
  });
}
